<template>

  <div class="container">

    <div class="row">

      <div class="col-12 offset-0 col-md-6 offset-md-3 text-center">

        <h3 class="mb-4 menu-dark font-weight-light">Whoops!</h3>

        <p class="menu-dark font-weight-normal">Please re-login via the app.</p>

      </div>

    </div>

  </div>

</template>

<script>

export default {
  name: 'ReAuthRequired',
}
</script>
